export default __webpack_public_path__ + "static/media/manual.548f69b8.svg";